import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// import * as Sentry from '@sentry/angular-ivy';

if (environment.production) {
    enableProdMode();
}

// Sentry.init({
//     dsn: environment.sentryDsn,
//     integrations: [
//         // Registers and configures the Tracing integration,
//         // which automatically instruments your application to monitor its
//         // performance, including custom Angular routing instrumentation
//         new Sentry.BrowserTracing({
//             routingInstrumentation: Sentry.routingInstrumentation,
//         }),
//         // Registers the Replay integration,
//         // which automatically captures Session Replays
//         new Sentry.Replay()
//     ],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 0.01,

//     // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

//     // Capture Replay for 10% of all sessions,
//     // plus for 100% of sessions with an error
//     replaysSessionSampleRate: 0.01,
//     replaysOnErrorSampleRate: 0.01,
//     ignoreErrors: [new RegExp(`401 Unauthorized`, 'mi')]
// });

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));
